export default "__VITE_ASSET__6a53f6b3__"